import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Rol } from 'src/app/core/interfaces/user.interface';
import { LocationEntity } from 'src/app/core/services/location/domain/entities/location.entity';
import { ProvinceEntity } from 'src/app/core/services/location/domain/entities/province.entity';
import { GetLocationsUseCase } from 'src/app/core/services/location/domain/usecases/get-locations.usecase';
import { GetProvinceUseCase } from 'src/app/core/services/location/domain/usecases/get-province.usecase';

interface Localities {
  id: number;
  name: string;
}

@Component({
  selector: 'app-step-company-form',
  templateUrl: './step-company-form.component.html',
  styleUrls: ['./step-company-form.component.css'],
})
export class StepCompanyFormComponent implements OnInit {
  @Input() CompanyData: any = {};
  @Output() company = new EventEmitter<any>();
  @Output() back = new EventEmitter<number>();
  @Input() selectedRol!: Rol;
  @Input() messageCompany!: string;
  @Input() isNewCompany!: boolean;

  companyForm!: FormGroup;
  isCompany: boolean = false;

  provinces: ProvinceEntity[] = [];
  localities: Localities[] = [];

  constructor(
    private fb: FormBuilder,
    private getProvince: GetProvinceUseCase,
    private getLocations: GetLocationsUseCase
  ) {}

  async ngOnInit(): Promise<void> {
    this.initForm();
    await this.loadProvinces();

    if (this.CompanyData && Object.keys(this.CompanyData).length > 0) {
      this.isCompany = true;
      this.companyForm.patchValue(this.CompanyData);
      await this.loadLocalities(this.CompanyData.province_id);
    }
    this.companyForm
      .get('province')
      ?.valueChanges.subscribe((selectedProvince: any) => {
        const province = this.getProvinceIdByName(selectedProvince);
        if (province) {
          this.loadLocalities(province);
          this.companyForm.patchValue(
            { provincia: province },
            { emitEvent: false }
          );
        }
      });
  }

  private getProvinceIdByName(provinceName: string): string | undefined {
    const province = this.provinces.find((p) => p.name === provinceName);

    return province ? province.id : undefined;
  }

  initForm() {
    this.companyForm = this.fb.group({
      razon_social: ['', Validators.required],
      cuit: ['', Validators.required],
      phone: [
        '',
        [
          Validators.required,
          Validators.minLength(7),
          Validators.maxLength(15),
          Validators.pattern('^[0-9]*$'),
        ],
      ],
      province: ['', Validators.required],
      city: ['', Validators.required],
      street: ['', [Validators.required, Validators.maxLength(50)]],
      number: [
        null,
        [
          Validators.required,
          Validators.maxLength(5),
          Validators.pattern(/^[0-9]*$/),
        ],
      ],
      postal_code: [
        null,
        [Validators.required],
      ],
      email: ['', [Validators.required, Validators.email]],
      neighborhood: [''],
      floor_apartment: ['',[Validators.maxLength(10)]],
      tower: ['', [Validators.maxLength(30)]],
    });
  }

  async loadProvinces() {
    try {
      const result = await this.getProvince.execute();
      if (Array.isArray(result)) {
        this.provinces = result;
      }
    } catch (error) {
      console.error('Error fetching provinces', error);
    }
  }

  async loadLocalities(provinceId: string) {
    try {
      const localities = await this.getLocations.execute(provinceId);
      if (Array.isArray(localities)) {
        const localitiesList = this.putIdToLocalitiesList(localities);

        this.localities = localitiesList;
      }
    } catch (error) {
      console.error('Error fetching localities', error);
    }
  }
  putIdToLocalitiesList(list: LocationEntity[]): Localities[] {
    let listWithId: Localities[] = [];
    for (let i = 0; i < list.length; i++) {
      let city: Localities = {
        id: i,
        name: list[i].name,
      };
      listWithId.push(city);
    }
    return listWithId;
  }

  submitForm() {
    if (this.companyForm.valid) {
      this.company.emit(this.companyForm.value);
    }
  }

  goBack() {
    this.back.emit(1);
  }

  hasErrors(controlName: string, errorType: string) {
    return (
      this.companyForm.get(controlName)?.hasError(errorType) &&
      this.companyForm.get(controlName)?.touched
    );
  }
}
